import React from 'react'

const MuiImage = (props) => {
  return <img alt='' {...props} />
}

export default MuiImage
